import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, ref } from 'vue'
import { VueEditor } from 'vue2-editor'
import BKEditorConfig from '@/common/vue2Config'
import { Organization, OrganizationDocument } from '@/modules/Organizations/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationSettingsAgreement',
  props: {
    org: null,
    isLoading: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  org: Organization
  isLoading: boolean
};

const instance = getCurrentInstance()





const editorConfig = ref(BKEditorConfig)

const updateAgreement = () => {
  const plainText = props.org.agreement.text.replace(/<[^>]*>?/gm, '').trim()
  if (!plainText && !props.org.agreement.title && !props.org.agreement.subtitle && !props.org.agreement.version) {
    props.org.agreement = {} as OrganizationDocument
    emit('update')
    return
  }
  props.org.agreement.text = instance?.proxy?.$sanitize(props.org.agreement.text)
  emit('update')
}

return { __sfc: true,instance, props, emit, editorConfig, updateAgreement, VueEditor }
}

})